import React from "react";
import { Card, CardContent, Typography, FormControlLabel, Switch, Box, Grid } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useMaterialUIController, setFixedNavbar, setDarkMode } from "context";

function Configuracion() {
  const [controller, dispatch] = useMaterialUIController();
  const { fixedNavbar, darkMode } = controller;

  const handleToggle = (setting) => {
    if (setting === "darkMode") {
      setDarkMode(dispatch, !darkMode);
    } else if (setting === "fixedNavbar") {
      setFixedNavbar(dispatch, !fixedNavbar);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ p: 3 }}>
        <Card>
          <CardContent>
            <Typography variant="h5" gutterBottom>
              Configuración General
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={<Switch checked={darkMode} onChange={() => handleToggle("darkMode")} />}
                  label="Modo Oscuro"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Switch checked={fixedNavbar} onChange={() => handleToggle("fixedNavbar")} />
                  }
                  label="Navbar Fijo"
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
      <Footer />
    </DashboardLayout>
  );
}

export default Configuracion;
